import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageFlags } from '@application/constants/country-flags';
import { LanguageCodeEnum, LanguageNameEnum } from '@application/enums/language';
const languages = [
    { code: LanguageCodeEnum.EN, name: LanguageNameEnum.EN, flag: LanguageFlags.English, ns: 'en' },
    { code: LanguageCodeEnum.NL, name: LanguageNameEnum.NL, flag: LanguageFlags.Dutch, ns: 'nl' }
];
const useLanguage = () => {
    const { i18n } = useTranslation();
    const [selectedLanguage, setSelectedLanguage] = useState(LanguageCodeEnum.EN);
    useEffect(() => {
        // Load from localStorage or default to current i18n language
        if (!i18n.language)
            return;
        const language = languages.find((obj) => obj.code === i18n.language);
        !!language && setSelectedLanguage(language.code);
        return;
    }, [i18n.language]);
    const handleLanguageChange = (languageCode, icon) => {
        const selectedLanguage = languages.find((lang) => lang.code === languageCode);
        if (!selectedLanguage)
            return;
        setSelectedLanguage(selectedLanguage.code);
        i18n.changeLanguage(selectedLanguage.code);
    };
    return {
        selectedLanguage,
        handleLanguageChange,
        languages
    };
};
export default useLanguage;
